import { v4 as uuidv4 } from "uuid";
import {
  IStudy,
  IStudyTreeItem,
  IStudyUserTreeItem,
} from "../../../../models/study.interface";
import ManagementTree from "../../ManageTree/ManagementTree";
import TreeStudyItem from "./TreeStudyItem/TreeStudyItem";
import TreeStudyUserItem from "./TreeStudyUserItem/TreeStudyUserItem";

const mapStudiesToStudiesTree = (studies: IStudy[]): IStudyTreeItem[] => {
  return studies.map((s) => ({
    ...s,
    childNodes:
      s.users.map((u) => {
        const treeUser: IStudyUserTreeItem = {
          ...u,
          userId: u.id,
          studyId: s.id,
          id: uuidv4(),
        };
        return treeUser;
      }) ?? [],
  }));
};

type ManageStudiesTreeProps = { studies: IStudy[] };

const ManageStudiesTree = ({ studies }: ManageStudiesTreeProps) => {
  const treeItemMapper = (
    item: IStudyTreeItem | IStudyUserTreeItem,
    nodeLvl?: number
  ) =>
    /**
     * Since there are only 2 levels for this tree ( 1.Study -> 2.Users),
     * If nodeLvl is = 0, render <TreeStudy>,
     * Else render <TreeUser>
     */
    !nodeLvl ? (
      <TreeStudyItem item={item as IStudyTreeItem} />
    ) : (
      <TreeStudyUserItem item={item as IStudyUserTreeItem} />
    );

  return (
    <ManagementTree
      defaultExpandAll
      data={mapStudiesToStudiesTree(studies)}
      treeItemMapper={treeItemMapper}
    />
  );
};

export default ManageStudiesTree;
